import { Component, OnInit, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { currencyOptionsConstant, titleOptionsConstant } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-ist-study-team-view',
  templateUrl: './ist-study-team-view.component.html',
  styleUrls: ['./ist-study-team-view.component.scss']
})
export class IstStudyTeamViewComponent implements OnInit {

  formFields;
  titleOptions = titleOptionsConstant;

  studyTeamTeamForm = new UntypedFormGroup({
    prefix: new UntypedFormControl(null),
    first_name: new UntypedFormControl(null),
    middle_name: new UntypedFormControl(null),
    last_name: new UntypedFormControl(null),
    occupation: new UntypedFormControl(null),

    speciality: new UntypedFormControl(null),
    medical_license_number: new UntypedFormControl(null),
    address: new UntypedFormControl(null),
    postal_code: new UntypedFormControl(null),
    city: new UntypedFormControl(null),

    state: new UntypedFormControl(null),
    country: new UntypedFormControl(null),
    preferred_contact_method: new UntypedFormControl(null),
    email_address: new UntypedFormControl(null),
    phone_number: new UntypedFormControl(null),


    ext_phone_number: new UntypedFormControl(null),
    other_phone_number: new UntypedFormControl(null),
    ext_other_phone_number: new UntypedFormControl(null),
    fax: new UntypedFormControl(null),
    ext_fax: new UntypedFormControl(null),

    organisation_name: new UntypedFormControl(null),
    user_role: new UntypedFormControl(null),
    cv_upload_attachment: new UntypedFormControl(null),
    notes: new UntypedFormControl(null)
  })

  content: any;
  heading: string;
  action: Subject<any> = new Subject();

  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  currencyOptions = currencyOptionsConstant;

  constructor(
  ) {
  }

  ngOnInit() {
   
  }

  operations = [
    { name: 'Save', type: 'submit', callback: this.save, self: this }
  ]

  onCallbackOperation(opr) {
    opr.callback();
  }

  save(){

  }

  showFiles() {
    let files = '';
    if (this.files && this.files.length > 0) {
      for (let i = 0; i < this.files.length; i++) {
        files += this.files[i].name;
        if (!(this.files.length - 1 === i)) {
          files += ',';
        }
      }
    }
    return files;
  }

  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  onUploadOutput(output: any | any): void {

    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.showFiles();
  }

}
